var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "sh": "Product",
            "tabActive": "Organic Line",
            "bg": "/images/sub/visual/sv-product.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('sub-section', {
    staticClass: "page-section--first"
  }, [_c('sub-product', {
    attrs: {
      "tit": "Organic Line",
      "file": "organic"
    }
  }, [_vm._v(" 유기농 코튼, BCI코튼, 리싸이클 폴리에스터, 대나무 섬유, 옥수수 섬유(소로나), 에코베로 등. 환경 문제가 대두됨에 따라 원단 시장 또한 변화하고 있습니다. 메이텍스는 환경 인증된 공장들과 협력하며 다양한 친환경 소재를 다루고 있습니다. ")])], 1), _c('sub-section', {
    staticClass: "page-section--last"
  }, [_c('v-container', [_c('v-row', {
    staticClass: "py-30 py-md-60 px-30",
    staticStyle: {
      "border": "1px solid #e6e6e6"
    }
  }, [_c('v-card', {
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "flat": ""
    }
  }, [_c('v-img', {
    staticStyle: {
      "max-width": "600px"
    },
    attrs: {
      "src": "/images/sub/product/organic/main_img.png"
    }
  })], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }